export default "__VITE_ASSET__MpcN6WK8__"